export const SENDING_REQUEST = 'CLASSIFIERFORM_SENDING_REQUEST';
export const CREATE_SUCCESS = 'CLASSIFIERFORM_CREATE_SUCCESS';
export const UPDATE_SUCCESS = 'CLASSIFIERFORM_UPDATE_SUCCESS';
export const FAILURE = 'CLASSIFIERFORM_FAILURE';
export const RESET_FORM = 'CLASSIFIERFORM_RESET_FORM';